module.exports = __webpack_public_path__ + "img/md-assessment-b.4ec0a895.svg";